<template>
  <component
    v-model="model"
    :is="mediaType + '-preview'"/>
</template>

<script>
import audioPreview from './audio-preview'
import imagePreview from './image-preview'
import pdfPreview from './pdf-preview'
import videoPreview from './video-preview'

export default {
  components:{
    audioPreview,
    imagePreview,
    pdfPreview, 
    videoPreview
  },
  props: {
    value: { type: null, default: '' }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(model) {
        this.$emit('input', model)
      }
    },
    mediaType(){
      if(this.model.mime_type == 'application/pdf'){
        return 'pdf'
      }

      return this.model.mime_type.substr(0, this.model.mime_type.indexOf('/')) 
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.model = val
    }
  },
  methods: {

    mediaUrl() {
      return this.model.thumbnail
        ? this.model.thumbnail.url
        : this.model.url
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/media/media-preview.vue